import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import '../styles/saveEditsReminderModal.scss';
import ButtonComponent from './ButtonComponent';
import CheckBox from './CheckBox';
import Popup from './Popup';
import { t } from 'i18next';
import { getImageSrc } from '../helper/imageBlobCache';
// localStorage key for the "don't remind me again" preference. When set to
// "1" the reminder is suppressed for this browser/profile.
export var SAVE_EDITS_REMINDER_SUPPRESSED_KEY = 'iwb.saveEditsReminderSuppressed';
export var isSaveEditsReminderSuppressed = function () {
    try {
        return window.localStorage.getItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY) === '1';
    }
    catch (_a) {
        return false;
    }
};
var setSuppressed = function (suppressed) {
    try {
        if (suppressed)
            window.localStorage.setItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY, '1');
        else
            window.localStorage.removeItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY);
    }
    catch (_a) {
        // localStorage may be unavailable (private mode, quota); ignore.
    }
};
var SaveEditsReminderModal = function (props) {
    var showModal = props.showModal, setShowModal = props.setShowModal, onContinue = props.onContinue, onSaveAs = props.onSaveAs, onDismiss = props.onDismiss;
    var _a = useState(false), dontRemind = _a[0], setDontRemind = _a[1];
    /**
     * `commit` = the user answered the dialog with one of its two buttons, so the
     * checkbox is a decision and is written through (set OR cleared).
     *
     * A dismissal — Escape, the overlay, the X — passes `false` and writes
     * nothing. Ticking the box and then backing out is not an answer, and storing
     * it there suppressed the reminder permanently on a gesture that everywhere
     * else in the app means "never mind".
     */
    var close = function (commit) {
        if (commit)
            setSuppressed(dontRemind);
        else
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        setShowModal(false);
    };
    var handleContinue = function () {
        close(true);
        onContinue();
    };
    var handleSaveAs = function () {
        close(true);
        onSaveAs();
    };
    return (_jsx(Popup, { isOpen: showModal, 
        // Escape / overlay / X — a dismissal, not a decision, so the checkbox is
        // deliberately NOT persisted here. See `persistSuppression`.
        onClose: function () { return close(false); }, ariaLabelledBy: "serm-title", 
        // The body copy is the only text that says what "Save As" will do (save
        // under a NEW code). Without this, the first focusable in DOM order is the
        // "don't remind me again" checkbox, so a screen-reader user in forms mode
        // hears the title and the checkbox and never the sentence that
        // disambiguates the two buttons.
        ariaDescribedBy: "serm-body", children: _jsx("div", { className: "serm-container", children: _jsxs("div", { className: "serm-content", children: [_jsx("h1", { id: "serm-title", className: "serm-title", children: t('text.saveEditsReminderTitle') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { id: "serm-body", className: "serm-body", children: [_jsx("span", { className: "serm-bodyLine", children: t('text.saveEditsReminderBodyLine1') }), _jsx("span", { className: "serm-bodyLine", children: t('text.saveEditsReminderBodyLine2') })] }), _jsx("div", { className: "serm-checkboxRow", children: _jsx(CheckBox, { id: "saveEditsReminderDontRemind", checked: dontRemind, onClick: function () { return setDontRemind(function (prev) { return !prev; }); }, label: t('text.dontRemindMeAgain'), labelCSS: "serm-checkboxLabel", ariaLabel: t('text.dontRemindMeAgain') }) }), _jsxs("div", { className: "serm-buttons", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.continueWithoutSaving'), defaultCSS: "serm-btn serm-cancelBtn", normalCSS: "serm-cancelBtn", clickHandler: handleContinue }), _jsx(ButtonComponent, { type: "textType1", text: t('text.saveAs'), defaultCSS: "serm-btn serm-saveBtn", normalCSS: "serm-saveBtn", clickHandler: handleSaveAs })] }), _jsx("div", { className: "serm-footer", children: _jsx("img", { src: getImageSrc('./assets/images/popupColorPatch.svg'), tabIndex: -1, alt: "" }) })] }) }) }));
};
export default SaveEditsReminderModal;
